<template lang="pug">

  //-
    -
    - Modal "Confirmar escala"
    -
    -

  v-dialog(v-model="isVisible" max-width="1170px" width="100%" :persistent="loading" content-class="sosDialog--editGroup")
    //- v-dialog(v-model="isVisible" max-width="1170px" width="100%" transition="dialog-bottom-transition")

    .dialogHeader

      .dialogHeaderTitle
        | Confirmar escala

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close('manual')")

    .dialogScroll

      .dialogBody

        .dialogBodyContent

          div(class="confirm-scale-container")

            div(style="height: 100%;" class="d-flex flex-column align-center justify-center")
              p(class="confirm-scale-text")
                | Você confirma a criação da escala abaixo?

              //- Exemplo de uso do miniWeekAnalysis
              div(v-if="miniWeekAnalysis" style="margin-top: 10px; font-size: 14px; color: #666;")
                //- Explicação do X
                div(v-if="isMiniReleased" style="margin-top: 15px; padding: 10px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px;")
                  div(style="font-weight: bold; color: #856404; margin-bottom: 5px;")
                    | ⚠️ Atenção:
                  div(style="color: #856404; font-size: 13px;")
                    | Os dias marcados com
                    span(style="color: #ff4444; font-weight: bold;") ✗
                    | não serão disparados nesta operação.

              //- Informação sobre teclas de atalho
              keyboard-shortcuts-info

            v-card-actions.buttons-on-lg
              v-spacer
              v-btn(color="error" x-large @click="close()").px-4
                | Cancelar
              v-btn(:loading="loading" :disabled="loading" color="success" x-large @click.stop.prevent="RELEASE_WEEK_DUTIES").mr-0.px-4
                | Confirmar
              v-spacer

          div(v-if="week" id="scale-data" class="scaleContainer" :class="$vuetify.breakpoint.name")

            div(v-if="this.$vuetify.breakpoint.smAndUp" class="calendar-2")

              ul.row

                li(v-for="(period, pk) in ['morning', 'night']" :key="pk" :class="{ [period]: true, }")

                  .turn-flag
                    span(v-if="pk === 0") Dia
                    span(v-if="pk === 1") Noite

                  template(v-for="(day, dk) in week.value")

                    .turn(:key="dk" :class="{expiredDay: day.isExpired, anotherMonth: (day.day.get('month') !== actualMonth), 'day-excluded': shouldMarkDayWithX(day, dk) }")

                      .day(v-if="pk === 0" :key="'day'+dk")
                        | {{ day.day.format('ddd - DD/MM') }}

                      .space

                        .space-turn(v-for="(turn, t) in getTurnsToday(day, period)" :key="t")

                          span.turn-hour
                            span.turn-hour-first  {{ turn.turnHour }} às {{ turn.endTime }}
                            span.turn-hour-second Duração: {{ turn.turnDuration }}

                          .user-list

                            template(v-for="(user, k) in turn.users")

                              .dutyCard(:key="k" :class="{ 'dutyCard--available': user.confirmScaleModalStatus === 'available', 'dutyCard--expired': user.confirmScaleModalStatus === 'expired', 'dutyCard--assigned__expired': user.confirmScaleModalStatus === 'assigned_expired' }")
                                img(:src="user.confirmScaleModalImage" draggable="false" alt="").dutyCard__image
                                span.dutyCard__text {{ user.confirmScaleModalLabel }}

            div(v-else).calendar-2

              ul.row

                li(v-for="(day, dk) in week.value" :key="dk" class="mobLi")

                  template(v-for="(period, pk) in ['morning', 'night']")

                    .turn(:key="pk" :class="{ [period]: true, expiredDay: day.isExpired, anotherMonth: (day.day.get('month') !== actualMonth), 'day-excluded': shouldMarkDayWithX(day, dk) }")

                      .turn-flag
                        span(v-if="pk === 0") Dia
                        span(v-if="pk === 1") Noite

                      .space

                        .day(v-if="pk === 0" :key="'day'+dk")
                          | {{ day.day.format('ddd - DD/MM') }}

                        .space-turn(v-for="(turn, t) in getTurnsToday(day, period)" :key="t")

                          span.turn-hour
                            span.turn-hour-first  {{ turn.turnHour }} às {{ turn.endTime }}
                            span.turn-hour-second Duração: {{ turn.turnDuration }}

                          .user-list

                            template(v-for="(user, k) in turn.users")

                              .dutyCard(:key="k" :class="{ 'dutyCard--available': user.confirmScaleModalStatus === 'available', 'dutyCard--expired': user.confirmScaleModalStatus === 'expired', 'dutyCard--assigned__expired': user.confirmScaleModalStatus === 'assigned_expired' }")
                                img(:src="user.confirmScaleModalImage" draggable="false" alt="").dutyCard__image
                                span.dutyCard__text {{ user.confirmScaleModalLabel }}

</template>

<script>

  import KeyboardShortcutsInfo from '@/components/KeyboardShortcutsInfo'

  import { apiGetGroupScaleTurns } from '@/services/firebase'

  export default {
    name: 'ConfirmScaleModal',

    components: {
      'keyboard-shortcuts-info': KeyboardShortcutsInfo,
    },

    props: {
      actualMonth: { type: Number, default: () => undefined },
      actualYear: { type: Number, default: () => undefined },
      week: { type: Object, default: () => ({}) },
      miniWeekAnalysis: { type: Object, default: () => ({ previousMonthDays: 0, currentMonthDays: 0, nextMonthDays: 0, previousMonthDates: [], currentMonthDates: [], nextMonthDates: [] }) },
      getScaleTurnsToday: { type: Function, default: function (day, period) { return [] } },
      publishWeekDuties: { type: Function, default: function (week) {} },
    },

    data () {
      return {
        isVisible: false,
        loading: false,
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        slotType: "",
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      }
    },

    computed: {
      // Identifica se é um disparo mini (mês anterior/atual/posterior)
      isMiniReleased() {
        // console.log('isMiniReleased - miniWeekAnalysis:', this.miniWeekAnalysis, 'miniReleasedType:', this.miniWeekAnalysis?.miniReleasedType)
        return !!(this.miniWeekAnalysis && this.miniWeekAnalysis.miniReleased && this.miniWeekAnalysis.miniReleased.type)
      },

      // Identifica qual tipo de disparo mini é
      miniReleasedType() {
        if (this.miniWeekAnalysis && this.miniWeekAnalysis.miniReleased && this.miniWeekAnalysis.miniReleased.type) {
          return this.miniWeekAnalysis.miniReleased.type
        }

        return null
      },

      // Identifica qual botão foi usado para o disparo mini
      miniReleasedButton() {
        if (this.miniWeekAnalysis && this.miniWeekAnalysis.miniReleased && this.miniWeekAnalysis.miniReleased.button) {
          return this.miniWeekAnalysis.miniReleased.button
        }

        return null
      },

      // Verifica se um dia deve ser marcado com X (não será disparado)
      shouldMarkDayWithX() {
        return (day, dayIndex) => {
          // console.log('shouldMarkDayWithX:', day, dayIndex, this.miniReleasedType, this.isMiniReleased)
          if (!this.isMiniReleased || !this.miniReleasedType) {
            return false
          }

          const dayMonth = day.day.get('month')
          const dayYear = day.day.get('year')
          const currentMonth = this.actualMonth
          const currentYear = this.actualYear

          // console.log('shouldMarkDayWithX - dayMonth:', dayMonth, 'dayYear:', dayYear, 'currentMonth:', currentMonth, 'currentYear:', currentYear)

          switch (this.miniReleasedType) {
            case 'previous':
              // Dispara apenas os dias do mês anterior ao mês atual
              // Marca com X os dias que NÃO são do mês anterior (ou seja, são do mês atual ou posterior)
              const shouldMarkPrevious = (dayYear > currentYear || (dayYear === currentYear && dayMonth >= currentMonth))
              // console.log('shouldMarkPrevious:', shouldMarkPrevious)
              return shouldMarkPrevious

            case 'current':
              // Dispara apenas os dias do mês atual sendo visualizado
              // Marca com X os dias que NÃO são do mês atual (ou seja, são do mês anterior ou posterior)
              const shouldMarkCurrent = !(dayYear === currentYear && dayMonth === currentMonth)
              // console.log('shouldMarkCurrent:', shouldMarkCurrent)
              return shouldMarkCurrent

            case 'next':
              // Dispara apenas os dias do mês posterior ao mês atual
              // Marca com X os dias que NÃO são do mês posterior (ou seja, são do mês anterior ou atual)
              const shouldMarkNext = (dayYear < currentYear || (dayYear === currentYear && dayMonth <= currentMonth))
              // console.log('shouldMarkNext:', shouldMarkNext)
              return shouldMarkNext

            default:
              return false
          }
        }
      },
    },

    watch: {
      isVisible: {
        immediate: true,
        handler: function (newVisibility, oldVisibility) {
          // Se o modal foi fechado, remove o listener
          if (oldVisibility === true && newVisibility === false) {
            document.removeEventListener('keydown', this.handleKeydown)
          }
        },
      },
    },

    beforeDestroy () {
      // Remove o listener quando o componente for destruído
      document.removeEventListener('keydown', this.handleKeydown)
    },

    methods: {
      open (/* [staging-portaltelemedicina / master-portaltelemedicina] slotType = "" [staging-portaltelemedicina / master-portaltelemedicina] */)
      {
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.slotType = slotType
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
        this.isVisible = true

        // Adiciona listener para tecla ENTER quando modal abre
        this.$nextTick(() => {
          document.addEventListener('keydown', this.handleKeydown)
        })
      },

      close (type = '')
      {
        // Remove listener quando modal fecha
        document.removeEventListener('keydown', this.handleKeydown)

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        // Limpeza
        this.slotType = ""
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // Close window
        this.isVisible = false
      },

      //
      // ABAS
      //

      handleKeydown (event)
      {
        console.log('handleKeydown:', event.key, this.isVisible, this.loading)

        // Se pressionar ENTER e modal estiver ativo
        if (event.key === 'Enter' && this.isVisible && !this.loading)
        {
          event.preventDefault()

          this.RELEASE_WEEK_DUTIES()
        }
      },

      getTurnsToday (day, period) {
        const turns = this.getScaleTurnsToday(day, period)
        return turns.map(turn => ({
          ...turn,
          users: (turn.users || []).filter(u => !u._deletedFromAcompanhar),
        }))
      },

      async RELEASE_WEEK_DUTIES ()
      {
        // console.log('::: RELEASE_WEEK_DUTIES:', this.week)

        if (this.loading) return false

        // Dias da semana selecionada
        const daysOfWeek = this.week.value.map(day => day.dayFmtWzero) // Ano-Mes-Dia

        // Turnos

        this.loading = true
        const turns = await apiGetGroupScaleTurns(this.$route.params.groupID, this.$route.params.scaleID)
        this.loading = false

        if (!!turns === false) {
          alert('Não foi possível verificar os plantões da escala. Por favor, tente novamente ou fale com o nosso suporte.')
          return false
        }

        // Plantões dos turnos (da escala)
        const scaleDuties = []
        const turnsKeys = Object.keys(turns)
        turnsKeys.forEach(turnID => {
          const turn = turns[turnID]

          if (!!turn === true) {
            const isSolo = !!turn.shiftType === true && turn.shiftType === 'solo'

            if (!isSolo && turn.plantoes) {
              const turnDutiesDates = Object.keys(turn.plantoes)
              scaleDuties.push(...turnDutiesDates)
            }
          }
        }) // Ano-Mes-Dia

        // Verifica se os turnos tem algum plantão, se tiver, verifica se algum dos plantões existentes está dentro da semana selecionada
        const hasDutiesOnSelectedWeek = scaleDuties.length > 0 ? scaleDuties.some(scaleDutyDate => !!scaleDutyDate && daysOfWeek.indexOf(scaleDutyDate) >= 0) : false

        // [24/01/25] console.log('RELEASE_WEEK_DUTIES[scaleDuties]:', scaleDuties)

        if (!hasDutiesOnSelectedWeek) {
          alert('Você precisa adicionar pelo menos um plantão para disparar a semana.')
          return false
        }

        //
        // Notas em 18/Mar/2026:
        //
        // Aqui está limpando o CTRL+Z quando dispara uma semana, mesmo que a limpeza afete registros de OPERAÇÕES de outras semanas no CTRL+Z (VueX).
        // O ideal é que no futuro limpe do CTRL+Z apenas os nós relacionados a SEMANA DISPARADA.
        //

        this.$store.commit('CLEAR_EDIT_SCALE_CTRL_Z')

        // Executa disparo
        this.publishWeekDuties({
          week: this.week,
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          slotType: this.slotType,
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
          validateConflicts: "YES",
        })

        // this.isVisible = false
        this.close()
      },
    },
  }

</script>

<style scoped lang="scss" src="./ConfirmScaleModal.scss"></style>
